import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useMainSliderStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      margin: 'auto',
      fontFamily: 'Montserrat',
      position: 'relative',
      textAlign: 'center',
      maxWidth: '1440px',

      [theme.breakpoints.down(1400)]: {
        maxWidth: 1200,
        margin: 'auto'
      },

      [theme.breakpoints.down(1200)]: {
        maxWidth: 940
      },

      [theme.breakpoints.down(300)]: {
        maxWidth: 300
      }
    },

    swiperWrapper: {
      marginLeft: 'auto',
      marginRight: 'auto',
      position: 'relative',
      overflow: 'hidden',
      alignItems: 'start',
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'column',
      padding: 0,
      [theme.breakpoints.down(516)]: {
        margin: '0 60px',
        paddingLeft: '0px',
        paddingRight: '0px'
      },
      ['& div']: {
        display: 'inline-flex'
      }
    },

    wrap: {
      display: 'flex'
    },

    title: {
      marginTop: '46px',
      marginBottom: '53px',
      fontFamily: 'Roboto',
      fontSize: '34px',
      fontWeight: 400,
      lineHeight: '40px',
      letterSpacing: '0em'
    },

    buttons: {
      display: 'flex',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column'
      }
    },

    btn: {
      height: 67,
      borderRadius: 9,
      fontFamily: 'Montserrat',
      padding: '3px 28px',

      '& span': {
        fontSize: 14,
        textAlign: 'center'
      },

      [theme.breakpoints.down('xs')]: {
        marginBottom: 40,
        padding: '12px 16px'
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: 236,
        marginTop: 62
      }
    },

    firstBtn: {
      background: 'linear-gradient(97.4deg, #E52428 10.98%, #C40F13 70.66%)'
    },

    secondBtn: {
      backgroundColor: 'transparent',
      border: '2px solid rgb(161, 45, 49)',
      marginLeft: 40,
      [theme.breakpoints.down('xs')]: {
        marginLeft: 0
      }
    }
  })
)
